import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  get,
  noop,
  sumBy,
} from 'lodash';
import { compose, setDisplayName } from 'recompose';

import { formatPrice, updatedClassname } from 'helpers/utils';
import { injectIntl } from 'components';
import { FRInput } from 'elements';

class BottomPanel extends Component {
  static propTypes = {
    editDisabled: PropTypes.bool,
    fields: PropTypes.arrayOf(PropTypes.shape({
      colSpan: PropTypes.number,
    })),
    info: PropTypes.shape({
      discount: PropTypes.string,
    }).isRequired,
    isRestaurant: PropTypes.bool,
    refundedAmount: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    totalDue: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    currentActivity: PropTypes.shape({}),

    validateTax: PropTypes.func,
    changeTax: PropTypes.func,
    validateReduction: PropTypes.func,
    changeReduction: PropTypes.func,
    validateCredit: PropTypes.func,
    changeCredit: PropTypes.func,
    validateDeliveryFee: PropTypes.func,
    changeDeliveryFee: PropTypes.func,
    changeDiscountValue: PropTypes.func,
    formatMessage: PropTypes.func,
  };

  static defaultProps = {
    currentActivity: {},
    editDisabled: false,
    fields: [],
    isRestaurant: false,
    refundedAmount: null,
    totalDue: null,

    changeTax: noop,
    changeDeliveryFee: noop,
    changeDiscountValue: noop,
    formatMessage: noop,
  };

  static contextTypes = {
    isDistributor: PropTypes.bool,
  };

  state = {
    discountForNetDue: this.props.info.discount,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.info.discount !== this.props.info.discount) {
      this.setState({ discountForNetDue: nextProps.info.discount });
    }
  }

  render() {
    const {
      editDisabled,
      fields,
      info,
      isRestaurant,
      refundedAmount,
      totalDue,
      validateTax,
      changeTax,
      validateReduction,
      changeReduction,
      validateCredit,
      changeCredit,
      validateDeliveryFee,
      changeDeliveryFee,
      changeDiscountValue,
      currentActivity,
      formatMessage,
    } = this.props;
    const { discountForNetDue } = this.state;
    const isDeleted = get(info, 'contact.isDeleted') || get(info, 'contact.sellerProfile.isOff');
    const priceIndex = fields.findIndex(field => field.name === 'priceTotal');
    const colSpanSum = sumBy(fields.slice(0, priceIndex + 1), field => field.colSpan || 1);
    const colSpanExtra = sumBy(fields.slice(priceIndex + 1), field => field.colSpan || 1);
    const totalDueColStyle = { width: 60, display: 'inline-block', fontSize: 14 };
    const discountRate = (100 - discountForNetDue) / 100;

    return (
      <div className="bottom-panel-wrapper">
        <table style={{ tableLayout: 'fixed' }} className="pull-right">
          <tbody>
            <tr>
              <td
                colSpan={colSpanSum}
                key={`${info.discount}-${info.deliveryFee}-${totalDue}`}
                className={updatedClassname(this, 'discount', `${info.discount}-${info.deliveryFee}-${totalDue}`)}
              >
                <div className="view-discount">
                  <div>
                    <span className="normal">
                      {formatMessage(isRestaurant ? 'TOTAL' : 'GROSS TOTAL')}:
                    </span>
                    <span
                      className="gross-total"
                      style={totalDueColStyle}
                    >
                      ${formatPrice(totalDue)}
                    </span>
                  </div>
                  { (!(info.type === 'PO' || isDeleted) || info.discount > 0) && (
                    <div
                      style={{
                        color: 'gray',
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}
                      className={currentActivity.field === 'discount' ? 'highlighted' : undefined}
                    >
                      <div className="discount-wrap">
                        <span
                          className="discount"
                          style={{
                            alignItems: 'center',
                            display: 'inline-flex',
                          }}
                        >
                          {
                            info.type === 'PO' || isDeleted ? (discountForNetDue || 0) : (
                              <FRInput
                                disabled={info.authorized || editDisabled}
                                id="discount"
                                inputProps={{
                                  style: {
                                    textAlign: 'right',
                                  },
                                }}
                                max={100}
                                min={0}
                                name="discount"
                                onBlur={changeDiscountValue}
                                onChange={(event) => {
                                  if (event.target.value > 100) return;
                                  this.setState({ discountForNetDue: event.target.value });
                                }}
                                style={{
                                  display: 'inline',
                                  fontSize: 13,
                                  overflow: 'hidden',
                                  width: 40,
                                  flexBasis: 200,
                                }}
                                className="discount-input"
                                type="number"
                                value={discountForNetDue || 0}
                              />
                            )
                          }%
                        </span>
                      </div>
                      <div>
                        <span className="normal">
                          % {formatMessage('DISCOUNT')}:
                        </span>
                        <span style={totalDueColStyle}>
                          -${formatPrice(((totalDue * discountForNetDue) / 100).toFixed(2))}
                        </span>
                      </div>
                    </div>
                  )}

                  {/* REDUCTION */}
                  <div className={`d-flex justify-content-end align-items-center ${currentActivity.field === 'reduction' && 'highlighted'}`}>
                    <div className="reduction-wrap">
                      <div style={{ width: 13 }}>
                        $
                      </div>
                      <FRInput
                        className="reduction-input"
                        defaultValue={parseFloat(info.reduction || 0).toFixed(2)}
                        disabled={info.type === 'PO' || info.authorized || editDisabled}
                        inputProps={{
                          style: {
                            textAlign: 'right',
                            fontSize: 14,
                          },
                        }}
                        onChange={validateReduction}
                        onBlur={changeReduction}
                        style={{
                          display: 'inline',
                          overflow: 'hidden',
                          width: 60,
                          marginRight: -13,
                        }}
                        type="number"
                      />
                    </div>
                    <div>
                      <span>
                        $ {formatMessage('DISCOUNT')}:
                      </span>
                      <span style={totalDueColStyle}>
                        -${parseFloat(info.reduction || 0).toFixed(2)}
                      </span>
                    </div>
                  </div>
                  {/* END OF REDUCTION */}

                  {/* CREDIT */}
                  <div className={`d-flex justify-content-end align-items-center ${currentActivity.field === 'credit' && 'highlighted'}`}>
                    <div className="credit-wrap">
                      <div style={{ width: 13 }}>
                        $
                      </div>
                      <FRInput
                        className="credit-input"
                        defaultValue={parseFloat(info.credit || 0).toFixed(2)}
                        disabled={info.type === 'PO' || info.authorized || editDisabled}
                        inputProps={{
                          style: {
                            textAlign: 'right',
                            fontSize: 14,
                          },
                        }}
                        onChange={validateCredit}
                        onBlur={changeCredit}
                        style={{
                          display: 'inline',
                          overflow: 'hidden',
                          width: 60,
                          marginRight: -13,
                        }}
                        type="number"
                      />
                    </div>
                    <div>
                      <span>
                        {formatMessage('CREDIT')}:
                      </span>
                      <span style={totalDueColStyle}>
                        -${parseFloat(info.credit || 0).toFixed(2)}
                      </span>
                    </div>
                  </div>
                  {/* END OF CREDIT */}

                  <div className="subtotal-wrap mt-1">
                    <span className="normal">
                      {formatMessage('SUBTOTAL')}:
                    </span>
                    <span
                      className="subtotal"
                      style={totalDueColStyle}
                    >
                      ${formatPrice((totalDue - ((totalDue * discountForNetDue) / 100) - (info.reduction || 0) - (info.credit || 0)))}
                    </span>
                  </div>
                  <div className={`d-flex justify-content-end align-items-center ${currentActivity.field === 'tax' && 'highlighted'}`}>
                    <div className="tax-wrap">
                      <div style={{ width: 13 }}>
                        $
                      </div>
                      <FRInput
                        className="tax-input"
                        defaultValue={parseFloat(info.tax || 0).toFixed(2)}
                        disabled={info.type === 'PO' || info.authorized || editDisabled}
                        inputProps={{
                          style: {
                            textAlign: 'right',
                            fontSize: 14,
                          },
                        }}
                        onChange={validateTax}
                        onBlur={changeTax}
                        style={{
                          display: 'inline',
                          overflow: 'hidden',
                          width: 60,
                          marginRight: -13,
                        }}
                        type="number"
                      />
                    </div>
                    <div>
                      <span>
                        {formatMessage('TAX')}:
                      </span>
                      <span style={totalDueColStyle}>
                        ${parseFloat(info.tax || 0).toFixed(2)}
                      </span>
                    </div>
                  </div>
                  {info.deliveryFee > 0 && (
                    <div className={`d-flex justify-content-end align-items-center ${currentActivity.field === 'deliveryFee' && 'highlighted'}`}>
                      <div className="delivery-fee-wrap">
                        <div style={{ width: 13 }}>
                          $
                        </div>
                        <FRInput
                          className="delivery-fee-input"
                          defaultValue={info.deliveryFee.toFixed(2)}
                          disabled={info.type === 'PO' || info.authorized || editDisabled}
                          inputProps={{
                            style: {
                              textAlign: 'right',
                              fontSize: 14,
                            },
                          }}
                          onChange={validateDeliveryFee}
                          onBlur={changeDeliveryFee}
                          style={{
                            display: 'inline',
                            overflow: 'hidden',
                            width: 60,
                            marginRight: -13,
                          }}
                          type="number"
                        />
                      </div>
                      <div>
                        <span className="red" >
                          {formatMessage('DELIVERY FEE')}:
                        </span>
                        <span className="red" style={totalDueColStyle}>
                          ${info.deliveryFee.toFixed(2)}
                        </span>
                      </div>
                    </div>
                  )}
                  <div className="total-due-wrap mt-1">
                    <b>
                      <span className="normal">
                        {formatMessage(isRestaurant ? 'TOTAL DUE' : ' NET DUE')}:
                      </span>
                      <span
                        className="totalDue"
                        style={totalDueColStyle}
                      >
                        ${formatPrice(((totalDue * discountRate) + info.deliveryFee + (info.tax || 0) - (info.reduction || 0) - (info.credit || 0)))}
                      </span>
                    </b>
                  </div>
                  {refundedAmount > 0 && (
                    <div>
                      <span className="normal">
                        {formatMessage('Refunded Amount')}:
                      </span>
                      <span
                        className="totalDue"
                        style={totalDueColStyle}
                      >
                        ${formatPrice((refundedAmount * discountRate).toFixed(2))}
                      </span>
                    </div>
                  )}
                </div>
              </td>
              <td
                colSpan={colSpanExtra}
                className="d-md-down-none"
              />
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default compose(
  setDisplayName('BottomPanel'),
  injectIntl,
)(BottomPanel);
